import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import promotion from './modules/promotion';
import wxsdk from './modules/wxsdk';
import orderGeneral from './modules/orderGeneral';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    orderKey: '',
    accidentRescueInfo: null
  },
  mutations: {
    setOderKey(state, orderKey) {
      state.orderKey = orderKey;
    },
    setAccidentRescueInfo(state, accidentRescueInfo) {
      state.accidentRescueInfo = accidentRescueInfo;
    }
  },
  actions: {

  },
  modules: {
    promotion,
    wxsdk,
    orderGeneral
  },
  plugins: [createPersistedState()]
});
